export default [
  {
    path: '/deposits/:key?',
    name: 'deposits',
    component: () => import('@/views/deposits/BADepositsIndex.vue'),
    meta: {},
  },
];
